// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  animation: fadeIn 0.3s ease;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 25px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
}

.stat-icon.blue {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.stat-icon.green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.stat-icon.red {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

.stat-icon.orange {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.stat-info h3 {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-primary);
}

.stat-info p {
  color: var(--text-secondary);
  font-size: 14px;
}

.dashboard-charts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 20px;
}

.chart-card {
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.chart-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.chart-card.full-width {
  grid-column: 1 / -1;
}

.chart-card h3 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
}

.chart-card h3 i {
  color: var(--primary-color);
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.activity-item {
  display: flex;
  gap: 15px;
  padding: 15px;
  background: var(--light-color);
  border-radius: 8px;
  transition: background 0.3s ease;
}

.activity-item:hover {
  background: #e5e7eb;
}

.activity-item i {
  font-size: 20px;
  color: var(--primary-color);
  margin-top: 2px;
}

.activity-item p {
  margin-bottom: 5px;
}

.activity-item span {
  font-size: 12px;
  color: var(--text-secondary);
}

.department-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dept-item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.dept-item > span:first-child {
  min-width: 100px;
  font-weight: 500;
}

.progress-bar {
  flex: 1 1;
  height: 10px;
  background: var(--light-color);
  border-radius: 5px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  border-radius: 5px;
  transition: width 0.3s ease;
}

.legend-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e5e7eb;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

/* Recharts tooltip customization */
.recharts-default-tooltip {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.recharts-tooltip-label {
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.recharts-tooltip-item {
  color: var(--text-secondary) !important;
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr;
  }

  .dashboard-charts {
    grid-template-columns: 1fr;
  }

  .chart-card.full-width {
    grid-column: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gFAAgF;EAChF,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".dashboard {\n  animation: fadeIn 0.3s ease;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  color: white;\n}\n\n.stat-icon.blue {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.stat-icon.green {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n\n.stat-icon.red {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n}\n\n.stat-icon.orange {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n.stat-info h3 {\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.stat-info p {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.dashboard-charts {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 20px;\n}\n\n.chart-card {\n  background: white;\n  padding: 25px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.chart-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.chart-card.full-width {\n  grid-column: 1 / -1;\n}\n\n.chart-card h3 {\n  margin-bottom: 20px;\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-primary);\n}\n\n.chart-card h3 i {\n  color: var(--primary-color);\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.activity-item {\n  display: flex;\n  gap: 15px;\n  padding: 15px;\n  background: var(--light-color);\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.activity-item:hover {\n  background: #e5e7eb;\n}\n\n.activity-item i {\n  font-size: 20px;\n  color: var(--primary-color);\n  margin-top: 2px;\n}\n\n.activity-item p {\n  margin-bottom: 5px;\n}\n\n.activity-item span {\n  font-size: 12px;\n  color: var(--text-secondary);\n}\n\n.department-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dept-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.dept-item > span:first-child {\n  min-width: 100px;\n  font-weight: 500;\n}\n\n.progress-bar {\n  flex: 1;\n  height: 10px;\n  background: var(--light-color);\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.progress {\n  height: 100%;\n  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));\n  border-radius: 5px;\n  transition: width 0.3s ease;\n}\n\n.legend-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 15px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n}\n\n.legend-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n}\n\n/* Recharts tooltip customization */\n.recharts-default-tooltip {\n  background: white !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;\n}\n\n.recharts-tooltip-label {\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.recharts-tooltip-item {\n  color: var(--text-secondary) !important;\n}\n\n@media (max-width: 768px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .dashboard-charts {\n    grid-template-columns: 1fr;\n  }\n\n  .chart-card.full-width {\n    grid-column: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
